import { useEffect, useState } from "react";
import { windowBreakpoint } from "../utils/constants";
import { isMobile } from "react-device-detect";

export const useScreenSizeDetector = () => {
  const [isLargeScreenSize, setIsLargeScreenSize] = useState<boolean>(
    window.innerWidth > windowBreakpoint
  );

  useEffect(() => {
    // Create a function to handle window resize events
    const handleWindowResize = () => {
      const newSize = isMobile || window.innerWidth <= windowBreakpoint;
      setIsLargeScreenSize(!newSize);
    };

    // Call handleWindowResize function once to set the initial value
    handleWindowResize();

    // Add event listener for window resize events
    window.addEventListener("resize", handleWindowResize);

    // Remove event listener for window resize events when component unmounts (cleanup)
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  const isSmallScreenSize = !isLargeScreenSize;

  return { isLargeScreenSize, isSmallScreenSize };
};
